import { render, staticRenderFns } from "./index_3.vue?vue&type=template&id=65a1fdd3&scoped=true"
import script from "./index_3.vue?vue&type=script&lang=js"
export * from "./index_3.vue?vue&type=script&lang=js"
import style0 from "./index_3.vue?vue&type=style&index=0&id=65a1fdd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1fdd3",
  null
  
)

export default component.exports